//#region all actions
export type ActionMode =
  | 'inspRestore'
  | 'inspFullDelete'
  | 'masterRestore'
  | 'masterDelete'
  | 'masterDeleteMultiple'
  | 'masterArchive'
  | 'masterCopy'
  | 'moveStart'
  | 'lineConnect'
  | 'lineCut'
  | 'lineTurn'
  | 'assignInsp'
  | 'assignMess'
  | 'assignError'
  | 'sortOrder'
  | 'xlSpez'
  | 'xlBauw'
  | 'xlHerst'
  | 'xlStammVorlageExp'
  | 'xlStammVorlageImp'
  | 'xlStammEditExp'
  | 'xlStammEditImp'
  | 'xlSpezEditExp'
  | 'xlSpezEditImp'
  | 'QRCode'
  | 'kav_calculate'
  | 'createTestDatabase'
  | 'createDevDatabase'
  | 'deleteTestDatabase'
  | 'deleteDevDatabase'
  | 'refreshDBConDictonary'
  | 'redoCheckDatabase'
  | 'railshift'
  | 'railbvbimport'
  | 'radiusbvbimport'
  | 'masterUnlock'
  | 'Gruppenberechtigungen'
  | 'Auftragsgruppenberechtigungen'
  | 'createBackupDatabase'
  | 'checkLogs';
//#endregion

export const ACTION_TITLE = {
  //#region datenbank
  createTestDatabase: 'Testdatenbank erstellen',
  deleteTestDatabase: 'Testdatenbank löschen',

  createDevDatabase: 'Dev-Datenbank erstellen',
  deleteDevDatabase: 'Dev-datenbank löschen',

  refreshDBConDictonary: 'Connectionstring-Dictonary neu aufbauen',
  redoCheckDatabase: 'Datenbank prüfen und aktualisieren ',
  createBackupDatabase: 'Datensicherung erstellen ',
  //#endregion

  //#region prüfungen
  inspRestore: 'Prüfung wiederherstellen',
  inspFullDelete: 'Prüfung endgültig löschen',
  //#endregion

  //#region stammdaten
  masterRestore: 'Stammdaten wiederherstellen',
  masterDelete: 'Stammdaten endgültig löschen',
  masterDeleteMultiple: 'Stammdaten mehrfach endgültig löschen',
  masterArchive: 'Archivierte Objekte',
  masterCopy: 'Stammdaten kopieren',
  masterUnlock: 'Stammdaten Replikatsperre entsperren',
  //#endregion

  //#region gleise
  lineConnect: 'Gleise verbinden',
  lineCut: 'Gleise trennen',
  lineTurn: 'Gleis drehen',
  moveStart: 'Startposition verschieben',
  railshift: 'Profilsmessungen einpassen',
  railbvbimport: 'BVB - Stammdatenimport für Gleise',
  radiusbvbimport: 'BVB - Trassierung aus Radius',
  //#endregion

  //#region zuordnungen
  assignInsp: 'Prüfzuordnungen wieder herstellen',
  assignMess: 'Zuordnungen letzte Messung wieder herstellen',
  assignError: 'Fehlerklassenzuordnung wiederherstellen',
  sortOrder: 'Auftrag umsortieren',
  Gruppenberechtigungen: 'Objekte / Gruppenberechtigungen',
  Auftragsgruppenberechtigungen: 'Auftrag / Auftragsgruppen',
  //#endregion

  //#region export/import
  xlSpez: 'Spezifikationen',
  xlBauw: 'Bauwerke',
  xlHerst: 'Herstellungsdaten',

  xlStammVorlageExp: 'Vorgabe für Stammdatenimport erstellen',
  xlStammVorlageImp: 'Stammdatenliste aus Excel-Vorgabe importieren',

  xlStammEditExp: 'Stammdaten zum Bearbeiten nach Excel exportieren',
  xlStammEditImp: 'Bearbeitete Stammdatenliste aus Excel einlesen',

  xlSpezEditExp: 'Spezifikationen zum Bearbeiten nach Excel exportieren',
  xlSpezEditImp: 'Bearbeitete Liste mit Spezifikationen aus Excel einlesen',

  QRCode: 'QR-Code Labels erstellen',
  //#endregion

  //#region andere
  kav_calculate: 'KAV berechnen',
  checkLogs: 'Log-Einträge herunterladen',
  //#endregion
} as const satisfies Record<ActionMode, string>;

export const ACTION_TREE = [
  {
    groupTitle: 'Datenbank',
    actions: [
      ['createTestDatabase', 'deleteTestDatabase'],
      ['createDevDatabase', 'deleteDevDatabase'],
      ['refreshDBConDictonary', 'redoCheckDatabase', 'createBackupDatabase'],
    ],
  },
  {
    groupTitle: 'Inspektion',
    actions: [['inspRestore', 'inspFullDelete']],
  },
  {
    groupTitle: 'Stammdaten',
    actions: [
      ['masterRestore', 'masterDelete', 'masterDeleteMultiple', 'masterArchive'],
      ['masterCopy', 'masterUnlock'],
    ],
  },
  {
    groupTitle: 'Gleise',
    actions: [['lineConnect', 'lineCut', 'lineTurn', 'moveStart'], ['railshift'], ['railbvbimport', 'radiusbvbimport']],
  },
  {
    groupTitle: 'Zuordnungen',
    actions: [
      ['assignInsp', 'assignMess', 'assignError', 'sortOrder'],
      ['Gruppenberechtigungen', 'Auftragsgruppenberechtigungen'],
    ],
  },
  {
    groupTitle: 'Import/Export',
    actions: [
      ['xlSpez', 'xlBauw', 'xlHerst'],
      ['xlStammVorlageExp', 'xlStammVorlageImp'],
      ['xlStammEditExp', 'xlStammEditImp'],
      ['xlSpezEditExp', 'xlSpezEditImp'],
      ['QRCode'],
    ],
  },
  {
    groupTitle: 'KAV',
    actions: [['kav_calculate']],
  },
] as const satisfies { groupTitle: string; actions: Array<ActionMode>[] }[];
